import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "curved_line",
  "use": "curved_line-usage",
  "viewBox": "0 0 740 385",
  "content": "<symbol viewBox=\"0 0 740 385\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"curved_line\">\n<path d=\"M740 115.699L498.044 357.134C462.743 392.358 405.531 392.164 370.471 356.701L2 -16\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol